export default __webpack_public_path__ + "static/media/smartio.3de3a743.webp";